import { Component, ChangeDetectionStrategy, Input, EventEmitter, Output, OnInit, OnChanges } from '@angular/core';
import { DropdownItem } from '../dropdown/dropdown-list.component';

interface MenuItem extends DropdownItem {
  rotation: number;
}

@Component({
  selector: 'mode-format-builder-rotation',
  templateUrl: './rotation.component.html',
  styleUrls: ['./rotation.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RotationComponent implements OnInit, OnChanges {
  @Input() angle: number = Number.NaN;
  @Output() update = new EventEmitter<number>();

  menuItems: Array<MenuItem> = [
    {
      name: 'Auto',
      rotation: Number.NaN,
    },
    {
      name: '0°',
      rotation: 0,
    },
    {
      name: '+45°',
      rotation: 45,
    },
    {
      name: '+90°',
      rotation: 90,
    },
    {
      name: '-45°',
      rotation: -45,
    },
    {
      name: '-90°',
      rotation: -90,
    },
  ];
  selectedItem?: MenuItem;

  ngOnInit() {
    this.selectedItem = this.menuItems.find((item) => item.rotation === this.angle) ?? this.menuItems[0];
  }

  ngOnChanges() {
    this.selectedItem = this.menuItems.find((item) => item.rotation === this.angle) ?? this.menuItems[0];
  }

  /**
   * @description Handle rotation selection, emitting the new
   * LabelFormat properties per the selection
   */
  selectItem(item: MenuItem) {
    this.selectedItem = item;
    this.angle = this.selectedItem.rotation;
    this.update.emit(this.angle);
  }
}
